import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { FaUser } from '@react-icons/all-files/fa/FaUser';
import { FaTags } from '@react-icons/all-files/fa/FaTags';
import { FaFileUpload } from '@react-icons/all-files/fa/FaFileUpload';
import { FaComments } from '@react-icons/all-files/fa/FaComments';
import { FaPencilAlt } from '@react-icons/all-files/fa/FaPencilAlt';
import { IoMdCalendar } from '@react-icons/all-files/io/IoMdCalendar';
import { getCategoryIcon } from '../Common/icon-type';
import { MdUpdate } from '@react-icons/all-files/md/MdUpdate';
import { MdOpenInBrowser } from '@react-icons/all-files/md/MdOpenInBrowser';
import { getLocaleDateString } from '../../utils/helpers';
// import { GrDocumentUpdate } from '@react-icons/all-files/gr/GrDocumentUpdate';
// import { GrDocumentUpload } from '@react-icons/all-files/gr/GrDocumentUpload';

// Utilities
import kebabCase from 'lodash/kebabCase';
// import { CommentCount } from '@joyfulelement/disqus-react';
import config from '../../../content/meta/meta-config';
import { styled } from '@linaria/react';
const Meta = (props) => {
  const {
    slug,
    title,
    datePublished,
    dateModified,
    author: authorName,
    category,
    tags,
    disqus,
    theme,
  } = props;
  const disqusConfig = {
    url: config.siteUrl + slug,
    identifier: slug.slice(1, -1), //remove the '/' from datePublished & suffix
    title: title,
    language: 'zh_TW',
  };

  return (
    <MetaStyled theme={theme}>
      {/* <span>
        <GrDocumentUpdate size={22} /> 更新於 {getLocaleDateString(dateModified)}
      </span>
      <span>
        <GrDocumentUpload size={22} /> 發布於 {getLocaleDateString(datePublished)}
      </span> */}
      <span>
        <MdUpdate size={22} /> 更新於 {getLocaleDateString(dateModified)}
      </span>
      {/* <span>
        <MdOpenInBrowser size={22} /> 發布於 {getLocaleDateString(datePublished)}
      </span> */}
      {/* <span>
        <FaUser size={18} /> {authorName}
      </span> */}
      {/* <span>
        <FaComments size={18} />
        <Link to={slug + `#disqus_thread`}>
          <CommentCount shortname={disqus.shortname} config={disqusConfig} />
        </Link>
      </span> */}
      {/* {category && (
        <span>
          {getCategoryIcon(category, true, '', 24)}
          <Link to={`/category/${category.split(' ').join('-')}`} style={{ color: 'var(--textTitleLink)' }}>
            {category}
          </Link>
        </span>
      )} */}
      {tags && tags.length > 0 && (
        <span>
          <FaTags size={16} />
          {tags.map((tag) => (
            <React.Fragment key={tag}>
              <Link to={`/tags/${kebabCase(tag)}/`} style={{ color: 'var(--textTitleLink)' }}>
                {tag}
              </Link>
              <span> </span>
            </React.Fragment>
          ))}
        </span>
      )}
    </MetaStyled>
  );
};

Meta.propTypes = {
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string,
  author: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  disqus: PropTypes.object,
  theme: PropTypes.object.isRequired,
};

export default Meta;

const MetaStyled = styled.p`
  display: flex;
  flex-flow: row wrap;
  font-size: 0.8em;
  margin: ${(props) => props.theme.space.m} 0;
  background: transparent;

  svg {
    fill: ${(props) => props.theme.icon.color};
    margin: ${(props) => props.theme.space.inline.xs};
  }
  svg path {
    stroke: ${(props) => props.theme.icon.color};
  }
  span {
    align-items: center;
    display: flex;
    text-transform: uppercase;
    margin: ${(props) => props.theme.space.xs} ${(props) => props.theme.space.s}
      ${(props) => props.theme.space.xs} 0;
  }

  a {
    text-decoration: none;
    box-shadow: inset 0 -4px 0 var(--underline-color-link);
    margin: 0 3px 0 3px;
  }

  @media (min-width: 768px) {
    font-size: 1em;
    margin: calc(${(props) => props.theme.space.m} * 1.5) 0 ${(props) => props.theme.space.m};
  }

  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.blog.h1.size} * 1.11);
  }
`;
